import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FiCheck } from 'react-icons/fi'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import './ListColorTableRow.css'

import EditColorIdentity from '../EditColorIdentity'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
import NumberToMoney from '../../../shared/functions/NumberToMoney'

function ListColorTableRow({ dataArray, handleSelect, myPermissionEdit, myPermissionDelete, handleOnSuccess, enableSelect }) {
    const [modalEditColor, setModalEditColor] = useState(false)
    const [colorId, setColorId] = useState()
    const [colorName, setColorName] = useState('')
    const [colorClothId, setColorClothId] = useState(null)
    const [colorClothName, setColorClothName] = useState('')
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const editSuccess = () => {
        handleOnSuccess()
        setModalEditColor(false)
    }

    // Card "Sem tecido" (colorClothId null): apaga o cadastro da cor inteiro pra esse
    // fornecedor. Card de um tecido real: só tira a cor daquele tecido, ela continua
    // existindo nos outros tecidos.
    async function deleteColor(id) {
        let msgType = 'success'
        const data = colorClothId
            ? await api.post('/color/bulk-remove-cloth', { cloth: colorClothId, colorIds: [id] }, {
                headers: { Authorization: `Bearer ${JSON.parse(token)}` },
            }).then((response) => {
                if (response) { handleOnSuccess(); setModalDeleteItem(false) }
                return response.data
            }).catch((err) => { msgType = 'error'; return err.response.data })
            : await api.delete(`/color/delete/${id}`, {
                headers: { Authorization: `Bearer ${JSON.parse(token)}` },
            }).then((response) => {
                if (response) { handleOnSuccess(); setModalDeleteItem(false) }
                return response.data
            }).catch((err) => { msgType = 'error'; return err.response.data })

        setFlashMessage(data.message, msgType)
    }

    const handleOnSelect = (item) => {
        if (enableSelect) {
            handleSelect(item)
        }
    }

    return (
        <div className="clr-table-wrap">
            <table className="clr-table">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Tipo</th>
                        <th>Fornecedor</th>
                        <th>Tecido</th>
                        <th>Ref</th>
                        <th>Faixas de custo</th>
                        {!enableSelect && <th></th>}
                    </tr>
                </thead>
                <tbody>
                    {dataArray && dataArray.map((item) => (
                        <tr
                            key={item._cardKey || item._id}
                            className={`clr-table-row ${enableSelect ? 'clr-table-row-selectable' : ''}`}
                            onClick={() => handleOnSelect(item)}
                        >
                            <td className="clr-table-name-cell">
                                {enableSelect && <FiCheck className="clr-table-select-check" size={14} />}
                                {item.name}
                            </td>
                            <td>{item.colorType?.name || '-'}</td>
                            <td>{item.provider?.label || '-'}</td>
                            <td>{item.cloth?.name || 'Sem tecido'}</td>
                            <td>{item.ref || '-'}</td>
                            <td>
                                {item.costs?.length > 0 ? (
                                    <div className="clr-table-costs">
                                        {item.costs.map((c) => (
                                            <span className="clr-table-cost-item" key={c._id}>
                                                {c.description && `${c.description} — `}
                                                {c.minUnit}–{c.maxUnit} un: R$ {NumberToMoney(c.cost)}
                                            </span>
                                        ))}
                                    </div>
                                ) : (
                                    <span className="clr-table-pending">sem custo</span>
                                )}
                            </td>
                            {!enableSelect && (
                                <td className="clr-table-actions">
                                    {myPermissionEdit &&
                                        <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={(e) => { e.stopPropagation(); setColorId(item._id); setColorClothId(item.cloth?._id || null); setColorClothName(item.cloth?.name || ''); setModalEditColor(true) }} />
                                    }
                                    {myPermissionDelete &&
                                        <FaTrashAlt className="shd-icon-row-trash" title="Apagar" onClick={(e) => { e.stopPropagation(); setModalDeleteItem(true); setColorId(item._id); setColorName(item.name); setColorClothId(item.cloth?._id || null); setColorClothName(item.cloth?.name || '') }} />
                                    }
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>

            <Modal
                modalStatus={modalEditColor}
                changeStatus={setModalEditColor}
                w={45}
                content={
                    colorId && <EditColorIdentity id={colorId} clothId={colorClothId} clothName={colorClothName} handleOnSuccess={editSuccess} btCancelAction={() => setModalEditColor(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteColor(colorId)}
                message={colorClothId
                    ? `Deseja realmente remover essa cor do tecido "${colorClothName}"? A cor continua existindo nos outros tecidos e nesse fornecedor.`
                    : 'Deseja realmente excluir essa cor desse fornecedor? Isso apaga só o cadastro dela (ref, custo, imagem) para esse fornecedor — o item no catálogo de cores não é afetado e pode ser associado de novo depois.'}
                itemName={colorName}
            />
        </div>
    )
}

export default ListColorTableRow
